import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import Navbar from '@/components/Navbar';

const TermsAndConditions = ({ user }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <Navbar user={user} />

      <div className="max-w-5xl mx-auto px-4 py-24">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-gray-400 hover:text-[#d4a574] mb-8 transition-colors"
        >
          <ChevronLeft className="w-5 h-5" />
          Back to Home
        </button>

        <div className="glass-card p-8 sm:p-10">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4 gradient-text">Terms & Conditions</h1>
          <p className="text-gray-400 mb-10">The basic terms that apply when using Wearoclub.</p>

          <div className="space-y-8 text-gray-300 leading-relaxed">
            <section>
              <h2 className="text-2xl font-semibold text-[#f0d9b5] mb-3">Bookings and Services</h2>
              <p>
                Wearoclub enables customers to book designer consultations and related fashion services. Booking
                availability, pricing, and timelines may vary based on designer schedules and service area coverage.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#f0d9b5] mb-3">Payments and Cancellations</h2>
              <p>
                Payments must be completed through the platform workflow when required. Cancellation, refund, and
                rescheduling outcomes may depend on the booking stage, designer availability, and policies shown at checkout.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#f0d9b5] mb-3">Customer Responsibilities</h2>
              <p>
                Customers are expected to provide accurate booking information, maintain respectful conduct during home
                visits, and communicate any special requirements clearly before service delivery.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#f0d9b5] mb-3">Platform Use</h2>
              <p>
                By using Wearoclub, you agree not to misuse the platform, interfere with operations, or provide false
                information. We may update these terms over time, and continued use means you accept those updates.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
